<div class="guide1-step-3 tw-flex tw-flex-wrap tw-items-center">
  <div
    class="tw-mb-3 tw-w-full md:tw-pr-2 lg:tw-mb-0"
    [ngClass]="{
      'md:tw-flex-1 min-[1201px]:!tw-w-3/12 min-[1201px]:tw-flex-none': isLogin,
      'lg:tw-flex-1': !isLogin,
    }"
  >
    <search-input
      [placeholder]="'mysec.searchBusinesses'"
      [value]="params.filterString"
      (onSubmit)="handleSearch($event)"
    ></search-input>
  </div>

  @if (isLogin) {
    <div class="tw-flex tw-max-w-[50%] tw-pr-6 max-[1200px]:tw-hidden">
      @if (!params.isWatchList) {
        <div class="btn" [class.active]="showAllActive()" (click)="showAll()" data-t="filterClick">
          {{ 'Show All' | translate }}
        </div>
      }
      <ng-container>
        <ng-container *ngTemplateOutlet="status"></ng-container>
      </ng-container>
    </div>
  }
  <div class="tw-mb-2 tw-flex tw-items-center lg:tw-mb-0 lg:tw-ml-auto lg:tw-flex-none lg:tw-pl-4">
    <div class="dropdown tw-block tw-cursor-pointer tw-select-none tw-text-body" ngbDropdown>
      <div
        id="filterButton"
        [ngClass]="'tw-flex tw-items-center'"
        aria-controls="menu"
        ngbDropdownToggle
      >
        <span class="tw-pr-1 tw-font-semibold">{{ 'common.sortBy' | translate }}:</span>
        <span
          class="tw-line-clamp-1 tw-inline-block tw-overflow-ellipsis tw-whitespace-nowrap min-[1201px]:tw-max-w-[180px]"
          >{{ InvestmentSortType[params.orderBy] | translate }}</span
        >
        <i class="fa fa-caret-down tw-ml-2 tw-opacity-50"></i>
      </div>
      <div
        class="dropdown-menu tw-min-w-[250px] tw-max-w-full"
        ngbDropdownMenu
        role="menu"
        aria-labelledby="filterButton"
      >
        @for (type of InvestmentSortType | enumToArray; track type) {
          <div
            role="menuitem"
            class="dropdown-item font-weight-bold font-size-regular tw-cursor-pointer"
            (click)="selectFilterType(type.key)"
            data-t="sortClick"
          >
            {{ type.value | translate }}
          </div>
        }
      </div>
    </div>

    <div class="c-filter__divider"></div>

    <div class="tw-whitespace-nowrap">
      <app-campaign-filters-toggle
        [filterMenus]="filtersMenus"
        [filterTags]="filterTags"
        [selectedMenu]="selectedFilterMenu"
        [selectedMenuIndex]="selectedFilterMenuIndex"
        [portalName]="'#c-filter__dropdown-section-pstx'"
        (onSelectedMenuChange)="handleSelectedMenuChange($event)"
        (onFiltersChange)="handleFiltersChange($event)"
      >
      </app-campaign-filters-toggle>
    </div>
  </div>

  <div id="c-filter__dropdown-section-pstx" class="c-filter__dropdown-section tw-w-full"></div>

  @if (filterTags.length > 0) {
    <div class="tw-mt-1 tw-w-full">
      <ul class="filter-tag">
        @for (tag of filterTags; track tag) {
          <li class="filter-tag__item" (click)="handleRemoveTag(tag)">
            {{ tag.label }}
            <i class="fa fa-times"></i>
          </li>
        }
      </ul>
    </div>
  }

  @if (isLogin) {
    <div class="tw-flex tw-w-full tw-pb-1 tw-pt-2 min-[1201px]:tw-hidden">
      <ng-container *ngTemplateOutlet="status"></ng-container>
    </div>
  }
</div>

<ng-template #status>
  @for (status of InvestorShareMarketStatusFilter | enumToArray; track status) {
    @if (
      status.key != InvestorShareMarketStatusFilter.Watched ||
      (status.key == InvestorShareMarketStatusFilter.Watched && !params.isWatchList)
    ) {
      <div
        class="btn"
        [class.active]="params.investorShareMarketStatus.includes(status.key)"
        (click)="filterStatus(status.key)"
        data-t="filterClick"
      >
        {{ status.value | translate }}
        @if (params.investorShareMarketStatus.includes(status.key)) {
          <div class="pitchin-icon-clear tw-ml-2 tw-h-3 tw-w-3"></div>
        }
      </div>
    }
  }
</ng-template>
